if (!customElements.get('quick-add-bulk')) {
  customElements.define(
    'quick-add-bulk',
    class QuickAddBulk extends HTMLElement {
      constructor() {
        super();
        this.quantity = this.querySelector('quantity-input');
        console.log('Initialized QuickAddBulk with quantity:', this.quantity);

        const debouncedOnChange = debounce((event) => {
          const currentQuantity = parseInt(event.target.dataset.cartQuantity);
          console.log('Debounced onChange triggered:', event.target.value);
          console.log('Current data-cart-quantity:', currentQuantity);

          if (currentQuantity === 0) {
            console.log('Adding to cart');
            this.addToCart(event);
          } else {
            console.log('Updating cart');
            this.updateCart(event);
          }
        }, ON_CHANGE_DEBOUNCE_TIMER);

        this.addEventListener('change', debouncedOnChange.bind(this));
        this.listenForActiveInput();
        this.listenForKeydown();
        this.lastActiveInputId = null;
        const pageParams = new URLSearchParams(window.location.search);
        window.pageNumber = decodeURIComponent(pageParams.get('page') || '');
      }


      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source === 'quick-add') {
            return;
          }
          // If its another section that made the update
          this.onCartUpdate().then(() => {
            this.listenForActiveInput();
            this.listenForKeydown();
          });
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      getInput() {
        return this.querySelector('quantity-input input');
      }

      selectProgressBar() {
        return this.querySelector('.progress-bar-container');
      }

      listenForActiveInput() {
        if (!this.classList.contains('hidden')) {
          this.getInput().addEventListener('focusin', (event) => {
            console.log('Input focused:', event.target);
            event.target.select();
          });
        }
        this.isEnterPressed = false;
      }

      listenForKeydown() {
        this.getInput().addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            console.log('Enter key pressed');
            this.getInput().blur();
            this.isEnterPressed = true;
          }
        });
      }

      resetQuantityInput(id) {
        const input = document.getElementById(id);
        input.value = input.getAttribute('value');
        this.isEnterPressed = false;
      }

      cleanErrorMessageOnType(event) {
        event.target.addEventListener(
          'keypress',
          () => {
            event.target.setCustomValidity('');
          }, {
            once: true
          }
        );
      }

      onCartUpdate() {
        return new Promise((resolve, reject) => {
          fetch(`${this.getSectionsUrl()}?section_id=${this.closest('.collection,.search').dataset.id}`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              const sourceQty = html.querySelector(
                `#quick-add-bulk-${this.dataset.id}-${this.closest('.collection,.search').dataset.id}`
              );
              if (sourceQty) {
                this.innerHTML = sourceQty.innerHTML;
              }
              resolve();
            })
            .catch((e) => {
              console.error(e);
              reject(e);
            });
        });
      }

      updateCart(event) {
        this.lastActiveInputId = event.target.getAttribute('data-index');
        console.log('Updating cart for item:', this.lastActiveInputId);
        console.log('Current quantity:', event.target.value);

        // this.quantity.classList.add('quantity__input-disabled');
        this.selectProgressBar().classList.remove('hidden');
        setTimeout(() => {
          this.selectProgressBar().classList.add('hidden');
        }, 1500);

        const body = JSON.stringify({
          quantity: event.target.value,
          id: event.target.getAttribute('data-index'),
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: this.getSectionsUrl(),
        });

        console.log('Sending cart update request with body:', body);

        fetch(`${routes.cart_change_url}`, {
            ...fetchConfig('javascript'),
            ...{
              body
            }
          })
          .then((response) => {
            console.log('Received response:', response);
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);
            console.log('Parsed response state:', parsedState);
            this.quantity.classList.remove('quantity__input-disabled');
            if (parsedState.description || parsedState.errors) {
              console.error('Error in cart update:', parsedState.description);
              event.target.setCustomValidity(parsedState.description);
              event.target.reportValidity();
              this.resetQuantityInput(event.target.id);
              this.selectProgressBar().classList.add('hidden');
              event.target.select();
              this.cleanErrorMessageOnType(event);
              return;
            }

            this.renderSections(parsedState);

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'quick-add',
              cartData: parsedState
            });
          })
          .catch((error) => {
            console.error('Fetch error:', error);
          });
      }


      addToCart(event) {
        console.log('Adding to cart:', event.target.value);
        this.quantity.classList.add('quantity__input-disabled');
        this.selectProgressBar().classList.remove('hidden');
        setTimeout(() => {
          this.selectProgressBar().classList.add('hidden');
        }, 1500);
        this.lastActiveInputId = event.target.getAttribute('data-index');

        const body = JSON.stringify({
          items: [{
            quantity: parseInt(event.target.value),
            id: parseInt(this.dataset.id),
          }, ],
          sections: this.getSectionsToRender().map((section) => section.section),
        });

        fetch(`${routes.cart_add_url}`, {
            ...fetchConfig('javascript'),
            ...{
              body
            }
          })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);
            console.log('Cart updated state:', parsedState);

            // Find the item in parsedState and update the data-cart-quantity
            const item = parsedState.items.find(item => item.id === parseInt(this.dataset.id));
            if (item) {
              event.target.setAttribute('data-cart-quantity', item.quantity);
              console.log('Updated data-cart-quantity:', item.quantity);
            }

            this.quantity.classList.remove('quantity__input-disabled');
            if (parsedState.description || parsedState.errors) {
              event.target.setCustomValidity(parsedState.description);
              event.target.reportValidity();
              this.resetQuantityInput(event.target.id);
              this.selectProgressBar().classList.add('hidden');
              event.target.select();
              this.cleanErrorMessageOnType(event);
              // Error handling
              return;
            }

            this.renderSections(parsedState);

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'quick-add',
              cartData: parsedState
            });
          })
          .catch((error) => {
            console.error(error);
          });
      }


      getSectionsToRender() {
        return [{
            id: `quick-add-bulk-${this.dataset.id}-${this.closest('.collection-quick-add-bulk').dataset.id}`,
            section: this.closest('.collection-quick-add-bulk').dataset.id,
            selector: `#quick-add-bulk-${this.dataset.id}-${this.closest('.collection-quick-add-bulk').dataset.id}`,
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section',
          },
          {
            id: 'cart-total',
            section: 'cart-total',
            selector: '.shopify-section',
          },
          {
            id: 'CartDrawer',
            selector: '#CartDrawer',
            section: 'cart-drawer',
          },
        ];
      }

      getSectionsUrl() {
        if (window.pageNumber) {
          return `${window.location.pathname}?page=${window.pageNumber}`;
        } else {
          return `${window.location.pathname}`;
        }
      }

      getSectionInnerHTML(html, selector) {
        const element = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
        if (element) {
          return element.innerHTML;
        } else {
          console.warn(`Element not found for selector: ${selector}`);
          return '';
        }
      }

      renderSections(parsedState) {
        this.getSectionsToRender().forEach((section) => {
          const sectionElement = document.getElementById(section.id);

          if (!sectionElement) {
            console.warn(`Section element not found for ID: ${section.id}`);
            return;
          }

          if (
            sectionElement.parentElement &&
            sectionElement.parentElement.classList.contains('drawer')
          ) {
            parsedState.items.length > 0 ?
              sectionElement.parentElement.classList.remove('is-empty') :
              sectionElement.parentElement.classList.add('is-empty');

            setTimeout(() => {
              const overlay = document.querySelector('#CartDrawer-Overlay');
              if (overlay) {
                overlay.addEventListener('click', this.cart.close.bind(this.cart));
              }
            });
          }

          const elementToReplace = sectionElement.querySelector(section.selector) || sectionElement;
          if (elementToReplace) {
            const innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            if (innerHTML !== '') { // Check if getSectionInnerHTML returned valid HTML
              elementToReplace.innerHTML = innerHTML;
            } else {
              console.warn(`Element not found for selector: ${section.selector}`);
            }
          }
        });

        if (this.isEnterPressed) {
          const input = this.querySelector(`#Quantity-${this.lastActiveInputId}`);
          if (input) {
            input.select();
          }
        }

        this.listenForActiveInput();
        this.listenForKeydown();
      }
    }
  );
}
